export class TabCategory{
    constructor(
      public id: number,
      public product_card_id: number,
      public name: string,
      public order: number,
      public selectionRequired: boolean,
      public showMaterials: boolean,
      public finalProductId: number,
      public sosource: string = '3000',
      public image: string = '',
      public is_entry_option: boolean = false,
      public description: string = '') { }
}
